import { toDisplayString as _toDisplayString, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vModelText as _vModelText, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ba300d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "main-container" }
const _hoisted_2 = {
  key: 0,
  class: "detail-container"
}
const _hoisted_3 = { class: "detail-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "prompt" }, "Opacity:", -1))
const _hoisted_5 = { class: "detail-row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "prompt" }, "Colormap:", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "detail-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "prompt" }, "Stretch:", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "detail-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "prompt cutoff" }, "Low cutoff:", -1))
const _hoisted_13 = { class: "detail-row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "prompt cutoff" }, "High cutoff:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_vue_slider = _resolveComponent("vue-slider")!
  const _component_transition_expand = _resolveComponent("transition-expand")!
  const _directive_hide = _resolveDirective("hide")!

  return (_openBlock(), _createElementBlock("div", {
    id: "root-container",
    onMouseenter: _cache[11] || (_cache[11] = ($event: any) => (_ctx.hasFocus = true)),
    onMouseleave: _cache[12] || (_cache[12] = ($event: any) => (_ctx.hasFocus = false)),
    onFocus: _cache[13] || (_cache[13] = ($event: any) => (_ctx.hasFocus = true)),
    onBlur: _cache[14] || (_cache[14] = ($event: any) => (_ctx.hasFocus = false))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        focusable: "false",
        id: "name-label",
        class: "ellipsize",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isSelected = !_ctx.isSelected)),
        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.isSelected = !_ctx.isSelected), ["enter"]))
      }, _toDisplayString(_ctx.imageset.settings.name), 33),
      _withDirectives(_createVNode(_component_font_awesome_icon, {
        class: "icon-button",
        icon: "map-marker-alt",
        onClick: _ctx.handleGoto
      }, null, 8, ["onClick"]), [
        [_directive_hide, !_ctx.hasFocus]
      ]),
      _withDirectives(_createVNode(_component_font_awesome_icon, {
        class: "icon-button",
        icon: _ctx.imageset.settings.enabled ? 'eye' : 'eye-slash',
        onClick: _ctx.handleVisibility
      }, null, 8, ["icon", "onClick"]), [
        [_directive_hide, !_ctx.hasFocus]
      ]),
      _withDirectives(_createVNode(_component_font_awesome_icon, {
        class: "icon-button",
        icon: "times",
        onClick: _ctx.handleDelete
      }, null, 8, ["onClick"]), [
        [_directive_hide, !_ctx.hasFocus]
      ])
    ]),
    _createVNode(_component_transition_expand, null, {
      default: _withCtx(() => [
        (_ctx.isSelected)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_vue_slider, {
                  class: "scrubber",
                  modelValue: _ctx.twoWayOpacity,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.twoWayOpacity) = $event)),
                  max: 1,
                  duration: 0,
                  interval: 0.01,
                  contained: true,
                  "hide-label": true,
                  "use-keyboard": true
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.twoWayColorMapperName) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colormaps, (x) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: x.wwt,
                      key: x.desc
                    }, _toDisplayString(x.desc), 9, _hoisted_7))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.twoWayColorMapperName]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.twoWayScaleType) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uiScaleTypes, (x) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: x.wwt,
                      key: x.desc
                    }, _toDisplayString(x.desc), 9, _hoisted_10))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.twoWayScaleType]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "detail-input",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.twoWayVMinText) = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.twoWayVMinText,
                    void 0,
                    { lazy: true }
                  ]
                ]),
                _createVNode(_component_font_awesome_icon, {
                  class: "icon-button",
                  icon: "crosshairs",
                  size: "lg",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleCutoffInteract(false))),
                  onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.handleCutoffInteract(false)), ["enter"]))
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "detail-input",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.twoWayVMaxText) = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.twoWayVMaxText,
                    void 0,
                    { lazy: true }
                  ]
                ]),
                _createVNode(_component_font_awesome_icon, {
                  class: "icon-button",
                  icon: "crosshairs",
                  size: "lg",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleCutoffInteract(true))),
                  onKeyup: _cache[10] || (_cache[10] = _withKeys(($event: any) => (_ctx.handleCutoffInteract(true)), ["enter"]))
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 32))
}